import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import { LanguageService } from '@common/services';
import { CreateService } from '@apps/its2/models/create-service';

import { CsStepsSummaryBaseComponent } from '../../common/cs-steps-summary-base.component';

@Component({
    selector: 'aa-cs-step2-summary',
    templateUrl: './cs-step2-summary.component.html',
    styleUrls: [
        '../../create-service-summary/create-service-summary.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CsStep2SummaryComponent extends CsStepsSummaryBaseComponent
{
    @Input() cs: CreateService;
    public language: string;

    constructor (
        userLanguageService: LanguageService,
        protected store: Store<IAuroraState>
    )
    {
        super(store);

        this.language = userLanguageService.language;
    }
}
